var exports = {
  "G": "suggestions__2phypF",
  "B": "suggestionButton__tSpKsw",
};

module.exports = exports;
